import { render, staticRenderFns } from "./LawyerEdit.vue?vue&type=template&id=a1615c36&scoped=true"
import script from "./LawyerEdit.vue?vue&type=script&lang=js"
export * from "./LawyerEdit.vue?vue&type=script&lang=js"
import style0 from "./LawyerEdit.vue?vue&type=style&index=0&id=a1615c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1615c36",
  null
  
)

export default component.exports